/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2026)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { createContext } from "react"

import type { BackendOperationClient } from "~lib/BackendOperationClient"

export interface BackendOperationContextProps {
  /** Client for making backend operation requests without triggering a script rerun. */
  backendOperationClient?: BackendOperationClient
}

/**
 * Provides the BackendOperationClient to components that need server-side
 * operations without a script rerun (e.g., deferred downloads, lazy loading).
 */
export const BackendOperationContext =
  createContext<BackendOperationContextProps>({
    backendOperationClient: undefined,
  })

BackendOperationContext.displayName = "BackendOperationContext"
